import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import apiClient from "../../services/api/client";

const SignupResumePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setError("Missing resume token.");
      setLoading(false);
      return;
    }
    apiClient
      .get(`/api/tenants/resume/${token}`)
      .then((res) => {
        navigate("/checkout", { state: res.data });
      })
      .catch((err) => {
        setError(err.response?.data?.detail || "This signup link has expired.");
        setLoading(false);
      });
  }, [searchParams, navigate]);

  if (loading) return <div style={{ padding: 40, textAlign: "center" }}>Loading your saved setup...</div>;
  return (
    <div style={{ padding: 40, textAlign: "center" }}>
      <p>{error}</p>
      <a href="/signup">Start a new signup instead</a>
    </div>
  );
};

export default SignupResumePage;
